import script from "./ServiceStatusKeyBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatusKeyBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatusKeyBlock.vue?vue&type=style&index=0&id=31808ecb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31808ecb"]])

export default __exports__